import { t } from 'ember-intl';
import BvIcon from 'volta/components/bv-icon';
import BvInline from 'volta/components/bv-inline';
import BvTag from 'volta/components/bv-tag';
import BvText from 'volta/components/bv-text';

import type { TOC } from '@ember/component/template-only';
import type { MenuItemWithParent } from 'volta/services/app-nav-state';

interface BvAppSearchEntryMenuSignature {
  Args: {
    menu: MenuItemWithParent;
  };
}

const BvAppSearchEntryMenuComponent: TOC<BvAppSearchEntryMenuSignature> = <template>
  <BvInline @blockAlign='center' @gap='4' @wrap={{false}}>
    <BvIcon @glyph={{@menu.icon}} @hasBackdrop={{true}} @color='text-subdued' />
    <BvInline @gap='2'>
      {{#if @menu.parent.label}}
        <BvTag @size='sm' @text={{t @menu.parent.label}} />
      {{/if}}
      <BvText @text={{t @menu.label}} @variant='body-sm' class='u-color-secondary' />
    </BvInline>
  </BvInline>
</template>;

export default BvAppSearchEntryMenuComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvAppSearch::Entry::Menu': typeof BvAppSearchEntryMenuComponent;
    'bv-app-search/entry/menu': typeof BvAppSearchEntryMenuComponent;
  }
}
